import { render, staticRenderFns } from "./premium.vue?vue&type=template&id=59ab70c6&scoped=true&"
import script from "./premium.vue?vue&type=script&lang=js&"
export * from "./premium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ab70c6",
  null
  
)

export default component.exports